// Skill definitions database
export const SKILLS = {
    // ============ WARRIOR SKILLS ============
    slash: {
        id: 'slash',
        name: 'Slash',
        description: 'A basic melee attack that deals physical damage.',
        icon: '⚔️',
        type: 'attack',
        targetType: 'enemy',
        manaCost: 0,
        cooldown: 0,
        castTime: 0,
        range: 3,
        effects: [
            { type: 'damage', value: 15, damageType: 'physical' },
        ],
        requiredLevel: 1,
        requiredClass: ['warrior'],
        animation: 'slash',
        sound: 'sword_slash',
    },
    heroic_strike: {
        id: 'heroic_strike',
        name: 'Heroic Strike',
        description: 'A powerful strike that deals increased physical damage.',
        icon: '💥',
        type: 'attack',
        targetType: 'enemy',
        manaCost: 15,
        cooldown: 6,
        castTime: 0,
        range: 3,
        effects: [
            { type: 'damage', value: 35, damageType: 'physical' },
        ],
        requiredLevel: 2,
        requiredClass: ['warrior'],
        animation: 'heroic_strike',
        sound: 'heavy_slash',
    },
    shield_bash: {
        id: 'shield_bash',
        name: 'Shield Bash',
        description: 'Bash the enemy with your shield, dealing damage and stunning briefly.',
        icon: '🛡️',
        type: 'attack',
        targetType: 'enemy',
        manaCost: 20,
        cooldown: 12,
        castTime: 0,
        range: 3,
        effects: [
            { type: 'damage', value: 20, damageType: 'physical' },
            { type: 'debuff', value: 0, stat: 'stunned', duration: 2 },
        ],
        requiredLevel: 4,
        requiredClass: ['warrior'],
        animation: 'shield_bash',
        sound: 'shield_hit',
    },
    battle_cry: {
        id: 'battle_cry',
        name: 'Battle Cry',
        description: 'Let out a fierce battle cry, increasing attack power for 15 seconds.',
        icon: '📯',
        type: 'buff',
        targetType: 'self',
        manaCost: 25,
        cooldown: 45,
        castTime: 0,
        range: 0,
        effects: [
            { type: 'buff', value: 20, stat: 'attackPower', duration: 15 },
        ],
        requiredLevel: 6,
        requiredClass: ['warrior'],
        animation: 'battle_cry',
        sound: 'war_cry',
    },
    whirlwind: {
        id: 'whirlwind',
        name: 'Whirlwind',
        description: 'Spin in a circle, dealing damage to all nearby enemies.',
        icon: '🌀',
        type: 'attack',
        targetType: 'aoe',
        manaCost: 35,
        cooldown: 10,
        castTime: 0,
        range: 5,
        effects: [
            { type: 'damage', value: 25, damageType: 'physical' },
        ],
        requiredLevel: 8,
        requiredClass: ['warrior'],
        animation: 'whirlwind',
        sound: 'whoosh',
    },
    // ============ MAGE SKILLS ============
    fireball: {
        id: 'fireball',
        name: 'Fireball',
        description: 'Hurl a ball of fire at your enemy, dealing fire damage.',
        icon: '🔥',
        type: 'attack',
        targetType: 'enemy',
        manaCost: 20,
        cooldown: 3,
        castTime: 1.5,
        range: 30,
        effects: [
            { type: 'damage', value: 45, damageType: 'fire' },
        ],
        requiredLevel: 1,
        requiredClass: ['mage'],
        animation: 'cast_fireball',
        sound: 'fireball',
    },
    frost_bolt: {
        id: 'frost_bolt',
        name: 'Frost Bolt',
        description: 'Launch a bolt of frost that damages and slows the enemy.',
        icon: '❄️',
        type: 'attack',
        targetType: 'enemy',
        manaCost: 18,
        cooldown: 2,
        castTime: 1.2,
        range: 30,
        effects: [
            { type: 'damage', value: 35, damageType: 'ice' },
            { type: 'debuff', value: 30, stat: 'moveSpeed', duration: 4 },
        ],
        requiredLevel: 1,
        requiredClass: ['mage'],
        animation: 'cast_frostbolt',
        sound: 'frost_bolt',
    },
    arcane_missiles: {
        id: 'arcane_missiles',
        name: 'Arcane Missiles',
        description: 'Channel arcane energy to fire rapid missiles at your target.',
        icon: '✨',
        type: 'attack',
        targetType: 'enemy',
        manaCost: 30,
        cooldown: 0,
        castTime: 3,
        range: 35,
        effects: [
            { type: 'damage', value: 60, damageType: 'arcane' },
        ],
        requiredLevel: 3,
        requiredClass: ['mage'],
        animation: 'channel_missiles',
        sound: 'arcane_missiles',
    },
    blink: {
        id: 'blink',
        name: 'Blink',
        description: 'Teleport a short distance in the direction you are facing.',
        icon: '💫',
        type: 'utility',
        targetType: 'self',
        manaCost: 15,
        cooldown: 15,
        castTime: 0,
        range: 20,
        effects: [],
        requiredLevel: 5,
        requiredClass: ['mage'],
        animation: 'blink',
        sound: 'teleport',
    },
    meteor: {
        id: 'meteor',
        name: 'Meteor',
        description: 'Call down a meteor from the sky, devastating an area.',
        icon: '☄️',
        type: 'attack',
        targetType: 'ground',
        manaCost: 60,
        cooldown: 30,
        castTime: 2.5,
        range: 40,
        effects: [
            { type: 'damage', value: 120, damageType: 'fire' },
            { type: 'dot', value: 15, damageType: 'fire', duration: 6, tickRate: 1 },
        ],
        requiredLevel: 10,
        requiredClass: ['mage'],
        animation: 'cast_meteor',
        sound: 'meteor_impact',
    },
    // ============ HEALER/PRIEST SKILLS ============
    heal: {
        id: 'heal',
        name: 'Heal',
        description: 'Restore health to yourself or an ally.',
        icon: '💚',
        type: 'heal',
        targetType: 'ally',
        manaCost: 25,
        cooldown: 2,
        castTime: 1.5,
        range: 40,
        effects: [
            { type: 'heal', value: 50 },
        ],
        requiredLevel: 1,
        requiredClass: ['priest', 'paladin'],
        animation: 'cast_heal',
        sound: 'heal',
    },
    renew: {
        id: 'renew',
        name: 'Renew',
        description: 'Place a healing effect on the target that heals over time.',
        icon: '💖',
        type: 'heal',
        targetType: 'ally',
        manaCost: 20,
        cooldown: 0,
        castTime: 0,
        range: 40,
        effects: [
            { type: 'hot', value: 10, duration: 12, tickRate: 2 },
        ],
        requiredLevel: 2,
        requiredClass: ['priest'],
        animation: 'cast_renew',
        sound: 'buff_apply',
    },
    smite: {
        id: 'smite',
        name: 'Smite',
        description: 'Call down holy fire on an enemy.',
        icon: '⚡',
        type: 'attack',
        targetType: 'enemy',
        manaCost: 18,
        cooldown: 0,
        castTime: 1.2,
        range: 30,
        effects: [
            { type: 'damage', value: 30, damageType: 'holy' },
        ],
        requiredLevel: 1,
        requiredClass: ['priest'],
        animation: 'cast_smite',
        sound: 'holy_smite',
    },
    power_word_shield: {
        id: 'power_word_shield',
        name: 'Power Word: Shield',
        description: 'Create a protective shield around the target.',
        icon: '🔮',
        type: 'buff',
        targetType: 'ally',
        manaCost: 30,
        cooldown: 15,
        castTime: 0,
        range: 40,
        effects: [
            { type: 'buff', value: 80, stat: 'shield', duration: 30 },
        ],
        requiredLevel: 4,
        requiredClass: ['priest'],
        animation: 'cast_shield',
        sound: 'shield_apply',
    },
    // ============ ROGUE SKILLS ============
    backstab: {
        id: 'backstab',
        name: 'Backstab',
        description: 'Strike from behind for massive damage. Must be behind target.',
        icon: '🗡️',
        type: 'attack',
        targetType: 'enemy',
        manaCost: 30,
        cooldown: 6,
        castTime: 0,
        range: 3,
        effects: [
            { type: 'damage', value: 60, damageType: 'physical' },
        ],
        requiredLevel: 1,
        requiredClass: ['rogue'],
        animation: 'backstab',
        sound: 'stab',
    },
    stealth: {
        id: 'stealth',
        name: 'Stealth',
        description: 'Become invisible to enemies. Breaks on damage or ability use.',
        icon: '👤',
        type: 'buff',
        targetType: 'self',
        manaCost: 0,
        cooldown: 10,
        castTime: 0,
        range: 0,
        effects: [
            { type: 'buff', value: 1, stat: 'stealth', duration: 60 },
        ],
        requiredLevel: 2,
        requiredClass: ['rogue'],
        animation: 'stealth',
        sound: 'stealth_enter',
    },
    poison_blade: {
        id: 'poison_blade',
        name: 'Poison Blade',
        description: 'Coat your weapons in poison, adding damage over time to attacks.',
        icon: '🧪',
        type: 'buff',
        targetType: 'self',
        manaCost: 20,
        cooldown: 60,
        castTime: 0,
        range: 0,
        effects: [
            { type: 'buff', value: 8, stat: 'poisonDamage', duration: 30 },
        ],
        requiredLevel: 4,
        requiredClass: ['rogue'],
        animation: 'apply_poison',
        sound: 'poison_apply',
    },
    shadow_step: {
        id: 'shadow_step',
        name: 'Shadow Step',
        description: 'Teleport behind your target.',
        icon: '🌑',
        type: 'utility',
        targetType: 'enemy',
        manaCost: 15,
        cooldown: 20,
        castTime: 0,
        range: 25,
        effects: [],
        requiredLevel: 6,
        requiredClass: ['rogue'],
        animation: 'shadow_step',
        sound: 'teleport',
    },
    // ============ UNIVERSAL SKILLS ============
    basic_attack: {
        id: 'basic_attack',
        name: 'Attack',
        description: 'A basic attack.',
        icon: '👊',
        type: 'attack',
        targetType: 'enemy',
        manaCost: 0,
        cooldown: 1,
        castTime: 0,
        range: 3,
        effects: [
            { type: 'damage', value: 10, damageType: 'physical' },
        ],
        requiredLevel: 1,
    },
    bandage: {
        id: 'bandage',
        name: 'Bandage',
        description: 'Use a bandage to heal yourself over time. Breaks on damage.',
        icon: '🩹',
        type: 'heal',
        targetType: 'self',
        manaCost: 0,
        cooldown: 60,
        castTime: 3,
        range: 0,
        effects: [
            { type: 'hot', value: 15, duration: 8, tickRate: 1 },
        ],
        requiredLevel: 1,
    },
    sprint: {
        id: 'sprint',
        name: 'Sprint',
        description: 'Increase movement speed for a short duration.',
        icon: '🏃',
        type: 'buff',
        targetType: 'self',
        manaCost: 0,
        cooldown: 120,
        castTime: 0,
        range: 0,
        effects: [
            { type: 'buff', value: 50, stat: 'moveSpeed', duration: 8 },
        ],
        requiredLevel: 1,
    },
};
// Get skills by class
export function getSkillsForClass(className) {
    return Object.values(SKILLS).filter(skill => !skill.requiredClass || skill.requiredClass.includes(className));
}
// Get skills by level
export function getSkillsForLevel(level, className) {
    return Object.values(SKILLS).filter(skill => {
        if (skill.requiredLevel > level)
            return false;
        if (className && skill.requiredClass && !skill.requiredClass.includes(className)) {
            return false;
        }
        return true;
    });
}
// Default action bar setup for each class
export const DEFAULT_ACTION_BAR = {
    warrior: ['basic_attack', 'heroic_strike', 'shield_bash', 'battle_cry', 'whirlwind', 'bandage'],
    mage: ['fireball', 'frost_bolt', 'arcane_missiles', 'blink', 'meteor', 'bandage'],
    priest: ['smite', 'heal', 'renew', 'power_word_shield', 'bandage', 'sprint'],
    rogue: ['backstab', 'stealth', 'poison_blade', 'shadow_step', 'bandage', 'sprint'],
    default: ['basic_attack', 'bandage', 'sprint', '', '', ''],
};
//# sourceMappingURL=skills.js.map